/**
 * Normalize FastAPI ``detail`` (string | array | object) for user-visible messages.
 * Handles ``password_policy_violation`` (machine-readable i18n keys).
 */

const PASSWORD_POLICY_REASON_MESSAGES = {
  too_short: "Password: at least 12 characters with upper, lower, a number, and a symbol.",
  missing_uppercase: "Password must include an uppercase letter.",
  missing_lowercase: "Password must include a lowercase letter.",
  missing_digit: "Password must include a digit.",
  missing_symbol: "Password must include a symbol or punctuation.",
  too_common: "Password is too common.",
  all_digits: "Password must not be all digits.",
};

export function formatHttpApiDetail(detail) {
  if (detail == null || detail === "") return "";
  if (typeof detail === "string") return detail;
  if (typeof detail === "number" || typeof detail === "boolean") return String(detail);
  if (Array.isArray(detail)) {
    try {
      return detail
        .map((x) => {
          if (!x) return "";
          if (typeof x === "string") return x;
          if (x.msg) return String(x.msg);
          if (x.message) return String(x.message);
          return "";
        })
        .filter(Boolean)
        .join("; ");
    } catch (_) {
      return "";
    }
  }
  if (typeof detail === "object" && detail.code === "password_policy_violation") {
    const r = detail.reason;
    if (r && PASSWORD_POLICY_REASON_MESSAGES[r]) return PASSWORD_POLICY_REASON_MESSAGES[r];
    return detail.message || "Password does not meet requirements.";
  }
  if (typeof detail === "object" && detail.code === "CONTROL_DB_BUSY") {
    const um = detail.user_message != null ? String(detail.user_message).trim() : "";
    if (um) return um;
  }
  if (typeof detail === "object" && (detail.code === "SQLITE_PHYSICAL_EOL" || detail.code === "SQLITE_EOL_ENFORCE" || detail.code === "account_store_unavailable" || detail.code === "telegram_store_unavailable" || detail.code === "tenant_rate_limited")) {
    const um = detail.user_message != null ? String(detail.user_message).trim() : "";
    if (um) return um;
    if (detail.code === "tenant_rate_limited") return "Too many requests — wait a few seconds and retry.";
    return "Server busy — wait a moment and retry.";
  }
  if (typeof detail === "object" && detail.code === "device_acl_blocks_group_assign") {
    const um = detail.user_message != null ? String(detail.user_message).trim() : "";
    if (um) return um;
    return "Revoke per-board shares before assigning a notification group.";
  }
  if (typeof detail === "object") {
    const um = detail.user_message != null ? String(detail.user_message).trim() : "";
    if (um) return um;
    const m = detail.message != null ? String(detail.message).trim() : "";
    if (m) return m;
    const d = detail.detail != null && typeof detail.detail === "string" ? detail.detail.trim() : "";
    if (d) return d;
    // Never dump raw JSON blobs into operator toasts.
    return "Request could not be completed — try again or contact your admin.";
  }
  return String(detail);
}
